import { createContext } from "react";

import type { WorkspaceSummary } from "@/types/user";

/**
 * View-model de UI derivado de `AuthMeResponse` (ver `toUser` em AuthContext.tsx).
 *
 * Diferente dos types em `@/types/user`, este NAO espelha o contrato da API: e um
 * modelo interno do frontend que agrega campos computados (`name`, `initials`) e
 * por isso usa camelCase intencionalmente. A regra "snake_case ponta-a-ponta" do
 * projeto vale para o JSON da API e os types espelho do backend (`AuthMeResponse`,
 * ja em snake_case) — nao para view-models locais.
 */
export interface AuthUser {
  id: number;
  name: string;
  email: string;
  initials: string;
  emailVerified: boolean;
  phoneVerified: boolean;
  hasPhone: boolean;
  mfaEnabled: boolean;
  isPlatformAdmin: boolean;
  platformRoleSlug: string | null;
  permissions: string[];
  manageableWorkspaces: WorkspaceSummary[];
  activeWorkspaceId: number | null;
}

export interface AuthCtxValue {
  user: AuthUser | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthCtxValue>({
  user: null,
  loading: true,
  refresh: async () => {},
});
